<template>
  <div id="closed-display" class="two-column-wrap">
    <div class="col-wrap left-wrap">
      <p class="text-space welcome-text">Sorry We Missed You!</p>
      <p style="text-align: center">We aren't taking calls right now, check back during our next open hours to chat!</p>
    </div>
    <div class="col-wrap right-wrap stack-grid">
      <div class="side-image-overlay"></div>
      <table class="middle-text">
        <thead style="font-size:1.2em">
        <tr>
          <td colspan="2" style="padding-bottom: 10px">Open Hours</td>
        </tr>
        </thead>
        <tbody>
          <tr v-for="item in checkInfo">
            <td style="text-align: end">{{formatDay(item.day)}} :</td>
            <td style="text-align: start; padding-left: 5px">{{makeTimeString(item)}}</td>
          </tr>
        </tbody>
      </table>
      <div class="version-wrap">
        <p class="version-text">Version: {{version}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import PreviewAgent from "../assets/PreviewAgent.png"
import {capitalize, split} from 'lodash'

export default {
  name: "closedDisplay",
  keepAlive: false,
  props: {
    info: Object,
    mobile: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      PreviewAgent,
      version: '1.0.0',
      format: 'HH:mm:ss'
    }
  },
  computed: {
    checkInfo() {
      return this.info ? this.info.accountProperties.availability : []
    }
  },
  methods: {
    formatDay(day) {
      return capitalize(day)
    },
    makeTimeString(item) {
      if (!item.enabled) {
        return "Closed"
      } else {
        let {opensAt,closesAt} = item
        let open = Number(split(opensAt,":")[0])
        let close = Number(split(closesAt,":")[0])
        return `${open % 12} ${open > 12 ? 'PM' : 'AM'} - ${close % 12} ${close > 12 ? 'PM' : 'AM'}`
      }
    }
  }
}
</script>
